import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { AppState } from "src/app/core/app.state";
import { catchError, finalize, map, of, switchMap, tap } from "rxjs";
import { CommonService } from "src/app/shared/common.service";
import { SuppliersService } from "../services/suppliers.services";
import * as suppliersActions from "./suppliers.actions";
import { APIResponse } from "src/app/core/models/api-response";
import { ISupplier } from "../models/suppliers.models";
import { AlertEnums } from "src/app/shared/enums/shared.enums";

@Injectable()
export class SuppliersEffects {
  constructor(
    private actions$: Actions,
    public store: Store<AppState>,
    private suppliersServices: SuppliersService,
    private commonService: CommonService
  ) {}

  // fetch Suppliers
  FetchSuppliersEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(suppliersActions.FetchSuppliers),
      tap(() => {
        this.store.dispatch(suppliersActions.SetSupplierLoader({ isLoading: true }));
      }),
      switchMap((action) =>
        this.suppliersServices.listAllSuppliers(action.page, action.key).pipe(
          map((res: APIResponse<ISupplier>) => suppliersActions.FetchSuppliersSuccess({ suppliers: res })),
          catchError(() => of(
            suppliersActions.FetchSuppliersError()
          )),
          finalize(() => {
            this.store.dispatch(suppliersActions.SetSupplierLoader({ isLoading: false }));
          })
        )
      ),
    )
  );

  // add Supplier
  AddSupplierEffect$ = createEffect(() =>
    this.actions$.pipe(
      ofType(suppliersActions.AddSupplier),
      switchMap((action) =>
        this.suppliersServices.addSupplier(action.supplier).pipe(
          map((res: APIResponse<ISupplier>) => suppliersActions.AddSupplierSuccess({ supplier: res.object, index: action.index })),
          tap(() => {
            this.store.dispatch(suppliersActions.SetSupplierLoader({ isLoading: false }));
            this.commonService.showToast(
              AlertEnums.addSuccess, 
              'SUCCESS'
            );
          }),
          catchError(() =>
            of(
              suppliersActions.AddSupplierError()
            ).pipe(
              tap(() => {
                this.store.dispatch(suppliersActions.SetSupplierLoader({ isLoading: false }));
              }
              )
            )
          )
        )
      ),
      finalize(() => {
        this.store.dispatch(suppliersActions.SetSupplierLoader({ isLoading: false }));
      })
    )
  );
}
